import { render, staticRenderFns } from "./ChatAnswerPreview.vue?vue&type=template&id=7f2762d0&scoped=true&"
import script from "./ChatAnswerPreview.vue?vue&type=script&lang=js&"
export * from "./ChatAnswerPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChatAnswerPreview.vue?vue&type=style&index=0&id=7f2762d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2762d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
